<template>
  <base-icon-button v-on="$listeners"
                    :title="title">
    <base-material-design-icon icon="comment"/>
  </base-icon-button>
</template>

<script>
  import BaseIconButton from '@/components/base-components/base-icons/BaseIconButton';
  import BaseMaterialDesignIcon from '@/components/base-components/base-icons/BaseMaterialDesignIcon';

  export default {
    name: 'BaseIconButtonComment',
    components: { BaseMaterialDesignIcon, BaseIconButton },
    props: {
      title: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped>

</style>
